import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  orderWithinFromModel,
  validateOrderWithinCondition,
  type OrderWithinState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_WITHIN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderWithinState>>,
): ConditionType<OrderWithinState, Condition.OrderWithin> => ({
  name: CONDITION_NAMES[Condition.ORDER_WITHIN],
  description(state) {
    return t("Within {{count}} days of order", { count: +state });
  },
  Details(props: ConditionTypeDetailsProps<OrderWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return orderWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ORDER_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return validateOrderWithinCondition(state).valid;
  },
});
